// extracted by css-extract-rspack-plugin
export default {"input-core":"input-core___y74ZsWVa","input-core__leading-slot":"input-core__leading-slot___YrEV0Vz1","input-core__trailing-slot":"input-core__trailing-slot___qCFepb8_"};